import Loadable from "react-loadable";

export const CreateCompanyButton = Loadable({
  loader: () => import("../../../modules/create-company").then((module) => module.CreateCompanyButton) as Promise<any>,
  loading: () => null,
});
